<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ผู้ใช้งานทั้งหมด</span>
      </v-flex>
    </v-layout>

    <v-row>
      <v-col cols="3">
        <v-text-field
          placeholder="ชื่อ นามสกุล นักวิจัย"
          color="#3e7662"
          dense
          outlined
          v-model="searchData.researcherName"
          hide-details
        />
      </v-col>
      <!--            <v-col cols="3">-->
      <!--                <v-select-->
      <!--                        hide-details-->
      <!--                        clearable-->
      <!--                        :menu-props="{ bottom: true, offsetY: true }"-->
      <!--                        background-color="#3e7662"-->
      <!--                        dark-->
      <!--                        solo-->
      <!--                        flat-->
      <!--                        dense-->
      <!--                        label="ประเภทนักวิจัย"-->
      <!--                        :items="typeList"-->
      <!--                        item-text="name"-->
      <!--                        item-value="id"-->
      <!--                        v-model="searchData.typeID"-->
      <!--                />-->
      <!--            </v-col>-->
      <v-col class="shrink d-flex align-center justify-end">
        <v-btn color="#3e7662" dark @click="search">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <!-- Table -->
    <v-layout mt-6>
      <v-flex>
        <form-table
          v-if="reload"
          :headers="headers"
          :items="userList"
          on-view-data
          :EditUser="onHandleModal"
          :onModal="onModal"
        ></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateUser.last_page"
          :total-visible="9"
          @input="getUserList"
          v-model="paginateUser.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <!--        modal-->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <!--                <template v-slot:activator="{ on, attrs }">-->
        <!--                    <v-btn-->
        <!--                            color="primary"-->
        <!--                            dark-->
        <!--                            v-bind="attrs"-->
        <!--                            v-on="on"-->
        <!--                    >-->
        <!--                        Open Dialog-->
        <!--                    </v-btn>-->
        <!--                </template>-->
        <v-card>
          <v-card-title>
            <span class="headline">User Status</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="modal.remark" row>
                    <v-radio color="#3E7662" label="ปกติ" value="N"></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="Careful Monitoring"
                      value="C"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="Training Request"
                      value="T"
                    ></v-radio>
                    <v-radio
                      color="#ff3300"
                      label="Blacklist"
                      value="B"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mr-3"
                    dark
                    color="#bdbdbd"
                    @click="dialog = false"
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    dark
                    color="#3E7662"
                    @click="changeUserStatus"
                  >
                    บันทึก
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import { mapState } from "vuex";
import TextfieldForm from "../../components/input/TextfieldForm";

export default {
  components: {
    FormTable,
    Loading,
    TextfieldForm,
  },
  data: () => ({
    modal: {
      remark: "",
      userID: "",
    },
    dialog: false,
    reload: true,
    userDialog: false,
    modalTitle: "",
    paginateUser: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    researcherType: [],
    imageUrl: null,
    searchData: {
      researcherName: "",
      typeID: "",
    },
    typeList: [
      { id: 1, name: "สตาฟของ รพ. , พบ." },
      { id: 2, name: "บริษัทยา" },
      { id: 3, name: "พยาบาล" },
      { id: 4, name: "หมอ,แพทย์ประจำบ้าน,นักเรียนแพทย์ทหาร" },
      { id: 5, name: "บุคลากรนอกสังกัด" },
    ],
    isLoading: false,
    fullPage: true,
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      { text: "ชื่อ-นามสกุล", value: "name", align: "center", sortable: false },
      { text: "ตำแหน่ง", value: "position", align: "center", sortable: false },
      { text: "หน่วยงาน", value: "organize", align: "center", sortable: false },
      // { text: 'ประเภทนักวิจัย', value: 'researcherTypeID', align: "center", sortable: false, },
      // { text: 'ระบุประเภทนักวิจัย', value: 'checkUser', align: "center", sortable: false, },
      { text: "เข้าใช้งาน", value: "login", align: "center", sortable: false },
      { text: "ดูข้อมูล", value: "view", align: "center", sortable: false },
      { text: "แก้ไข", value: "edit", align: "center", sortable: false },
    ],
    userList: [],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.getUserList(1);
    this.getResearcherType();
  },
  methods: {
    // Get Research Type
    getResearcherType() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getResearcherType")
        .then((res) => {
          res.all_researcher_type.forEach((data) => {
            this.researcherType.push({
              id: data.id,
              typeName: data.typeName,
              typeCode: data.typeCode,
            });
          });
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    search() {
      if (this.searchData) {
        this.isLoading = true;
        this.$store
          .dispatch("User/searchResearcher", this.searchData)
          .then((res) => {
            this.userList = [];
            let j = 1;
            res.data.forEach((data) => {
              this.userList.push({
                number: j,
                name: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
                email: data.email,
                position: data.position ? data.position : "-",
                organize:
                  (data.affiliation && data.affiliation.affiliation) ?
                      (data.affiliation.affiliation !== 'อื่นๆ' ? data.affiliation.affiliation : data.otherAffiliation) : "-",
                id: data.id,
                linkView: "ViewUser",
                form: "UserManagement",
                deleteUser: data.id,
                // researcherTypeID: data.researcher_type == null? '-': data.researcher_type.typeName,
                onView: 12,
              });
              j++;
            });
            this.paginateUser.current_page = res.current_page;
            this.paginateUser.from = res.from;
            this.paginateUser.last_page = res.last_page;
            this.paginateUser.per_page = res.per_page;
            this.paginateUser.total = res.total;
            this.paginateUser.to = res.to;
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
            Swal.fire({
              title: "ไม่พบนักวิจัย",
              icon: "error",
              position: "center",
              confirmButtonText: "ตกลง",
              confirmButtonColor: "#3E7662",
            }).then(() => {
              this.getUserList(1);
            });
          });
      } else {
        Swal.fire({
          title: "กรุณากรอกข้อมูลที่ต้องการ ค้นหา",
          icon: "warning",
          position: "center",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#3E7662",
        });
      }
    },
    getUserList(page) {
      this.isLoading = true;
      this.$store
        .dispatch("User/getUserList", page)
        .then((res) => {
          this.userList = [];
          let i = 1;
          res.data.forEach((data) => {
            this.userList.push({
              number: i,
              name: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
              email: data.email,
              position: data.position ? data.position : "-",
              organize:
                  (data.affiliation && data.affiliation.affiliation) ?
                      (data.affiliation.affiliation !== 'อื่นๆ' ? data.affiliation.affiliation : data.otherAffiliation) : "-",
              id: data.id,
              remark: data.remark,
              linkView: "ViewUser",
              form: "UserManagement",
              deleteUser: data.id,
              researcherTypeID:
                data.researcher_type == null
                  ? "-"
                  : data.researcher_type.typeName,
              onView: 12,
            });
            i++;
          });
          this.paginateUser.current_page = res.current_page;
          this.paginateUser.from = res.from;
          this.paginateUser.last_page = res.last_page;
          this.paginateUser.per_page = res.per_page;
          this.paginateUser.total = res.total;
          this.paginateUser.to = res.to;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    onHandleModal(id) {
      this.$router.push({ name: "FormUser", query: { id: id } });
    },
    changeUserStatus() {
      this.isLoading = true;
      this.$store
        .dispatch("User/changeUserStatus", this.modal)
        .then((res) => {
          this.isLoading = false;
          this.dialog = false;
          Swal.fire({
            title: "Success",
            text: "บันทึกข้อมูลเรียบร้อย",
            confirmButtonColor: "#3E7662",
          }).then(() => {
            this.getUserList(this.paginateUser.current_page);
            // window.location.reload();
          });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // this.isLoading = false;
          // Swal.fire({
          //     title: 'เกิดข้อผิดพลาด',
          //     icon: 'warning',
          //     confirmButtonColor: '#3E7662',
          // })
        });
    },
    onModal(id, remark) {
      console.log(id, remark);
      this.modal.userID = id;
      this.modal.remark = remark;
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
</style>
